<template>
  <table class="table table-bordered table-responsive table-hover table-sm" v-if="cols && cols.length">
    <thead>
    <tr>
      <th v-for="col in cols">{{ col }}</th>
      <th class="inline-buttons"></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="row in rows">
      <td v-for="col in cols" class="inline-edit">
        <input type="text" class="inline-input form-control" v-model="row[col]" @change="updateRecord(row)">
      </td>
      <td class="inline-buttons">
        <button class="btn btn-outline-danger btn-sm" @click="deleteRecord(row.recordId)">
          <icon name="minus"></icon>
        </button>
      </td>
    </tr>
    <tr>
      <td v-for="col in cols" class="inline-edit">
        <input ref="newRecordInput" type="text" class="inline-input form-control" v-model="newRecord[col]">
      </td>
      <td class="inline-buttons">
        <button class="btn btn-outline-success btn-sm" @click="createRecord(newRecord)">
          <icon name="plus"></icon>
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
  import { uuid } from '../lib'
  import * as mutations from '../store/mutation-types'

  export default {
    name: 'dataset-table',
    props: ['datasetId'],
    data () {
      return {
        newRecord: {}
      }
    },
    computed: {
      dataset () {
        return this.$store.getters.dataset(this.datasetId) || {}
      },
      cols () {
        return this.dataset.columns
      },
      rows () {
        return this.dataset.records
      }
    },
    methods: {
      resetNewRecord () {
        this.newRecord = {}
        if (this.$refs.newRecordInput && this.$refs.newRecordInput[0]) {
          this.$refs.newRecordInput[0].focus()
        }
      },
      createRecord () {
        const record = Object.assign({}, this.newRecord, {recordId: uuid()})
        this.$store.commit(mutations.DATASET_CREATE_RECORD, {
          datasetId: this.datasetId,
          record,
          emit: true
        })
        this.resetNewRecord()
      },
      deleteRecord (recordId) {
        this.$store.commit(mutations.DATASET_DELETE_RECORD, {
          datasetId: this.datasetId,
          recordId,
          emit: true
        })
      },
      updateRecord (record) {
        this.$store.commit(mutations.DATASET_UPDATE_RECORD, {
          datasetId: this.datasetId,
          recordId: record.recordId,
          record,
          emit: true
        })
      }
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/dataset-table.vue